module.exports = __webpack_public_path__ + "0588290a.otf";